import CollapsedEvents from './CollapsedEvents/CollapsedEvents';
import Label from './Label/Label';
import LabeledIcon from './LabeledIcon/LabeledIcon';
import Icon from './Icon/Icon';
import Vehicle from './Vehicle/Vehicle';
import Driver from './Driver/Driver';
import Status from './Status/Status';
import ItemOverview from './ItemOverview/ItemOverview';
import ProceedToDetails from './ProceedToDetails/ProceedToDetails';
import StartEndTime from './StartEndTime/StartEndTime';
import Toggler from './Toggler/Toggler';
import Trip from './Trip/Trip';
import WithUnassign from './WithUnassign/WithUnassign';
import DeviceInfo from './DeviceInfo/DeviceInfo';
import HiddenDetails from './HiddenDetails/HiddenDetails';

export default {
  LabeledIcon,
  Label,
  Icon,
  Vehicle,
  Driver,
  Status,
  CollapsedEvents,
  ItemOverview,
  ProceedToDetails,
  StartEndTime,
  Toggler,
  Trip,
  WithUnassign,
  DeviceInfo,
  HiddenDetails,
};
